// Phase HR-003 Wave 7 — Welfare audit API client.
import apiClient from '@/shared/api/client'

export type FacilityType =
  | 'CANTEEN' | 'WATER' | 'TOILET' | 'LOCKER'
  | 'TRANSPORT' | 'HOSTEL' | 'REST_AREA'
  | 'WASHROOM' | 'FIRST_AID' | 'OTHER'

export interface WelfareCreate {
  plant_id: string
  observation_date: string
  facility_type: FacilityType
  condition_rating: number
  location_code?: string | null
  issue_observed?: string | null
  photo_url?: string | null
  linked_grievance_id?: string | null
  action_taken?: string | null
  action_owner_user_id?: string | null
  action_due_at?: string | null
}

export interface WelfareObservation extends WelfareCreate {
  id: string
  reported_by: string | null
  reported_by_name: string | null
  linked_grievance_no: string | null
  action_owner_name: string | null
  action_closed_at: string | null
  action_closure_notes: string | null
  is_overdue: boolean
  created_at: string
}

export interface WelfareStats {
  total: number
  avg_rating: number | null
  poor_count: number
  open_count: number
  overdue_count: number
  by_facility: Record<string, number>
  by_rating: Record<string, number>
}

const BASE = '/hr/welfare'

export const welfareApi = {
  create: async (body: WelfareCreate): Promise<WelfareObservation> =>
    (await apiClient.post<WelfareObservation>(BASE, body)).data,
  list: async (params?: {
    plant_id?: string; facility_type?: FacilityType
    open_only?: boolean; from_date?: string; to_date?: string; limit?: number
  }) => (await apiClient.get<WelfareObservation[]>(BASE, { params })).data,
  close: async (id: string, closure_notes: string) =>
    (await apiClient.post<WelfareObservation>(`${BASE}/${id}/close`,
      { action_closure_notes: closure_notes })).data,
  stats: async (params?: {
    plant_id?: string; from_date?: string; to_date?: string
  }) => (await apiClient.get<WelfareStats>(`${BASE}/stats`, { params })).data,
}
